import React, { useState, useEffect } from "react";
import ConsultationBookingModal from "../Modals/ConsultationBookingModal";
import "./MinorAilments.css";
import { useLocation } from "react-router-dom";

const MinorAilments = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleBookingSubmit = async (bookingDetails) => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/users/consultations`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bookingDetails),
      }
    );
    return response;
  };

  const ailments = [
    {
      title: "UTI",
      description:
        "Urinary tract infections are caused by bacteria entering the urinary tract. It is common among women.",
    },
    {
      title: "Pink Eye",
      description:
        "Conjuctivitis is an infalammation of the eye due to allergies, bacteria or viruses. It is contagious but treatable.",
    },
    {
      title: "Oral Thrush",
      description:
        "Oral thrush is a yeast infection that develops white cotton-like lesions on the tongue or inner cheek.",
    },
    {
      title: "Cold Sores",
      description:
        "Cold sores are painful blisters that form on the border of your lips. They are caused by Herpes-Simplex virus.",
    },
    {
      title: "Seasonal Allergies",
      description:
        "Hay fever can cause symptoms like sneezing, watery itchy eyes, runny and itchy nose. There are several treatment options to manage those symptoms.",
    },
    {
      title: "Vaginal Yeast Infection",
      description:
        "Vaginal yeast infection is an infection of the vagina caused by the fungus Candida Albicans. It causes itching, burning and changes to vaginal discharge.",
    },
    {
      title: "Acid Reflux",
      description:
        "Heart burn occurs when the stomach acid travels in your oesophagus. This causes burning discomfort in your upper belly or chest.",
    },
    {
      title: "Skin Inflammation & Eczema",
      description:
        "Dermatitis is an inflammation of the skin that causes redness , irritation and rash.",
    },
    {
      title: "Hemorrrhoids",
      description:
        "Hemorroids are swollen and inflammed veins in and around the anus & rectum",
    },
    {
      title: "Menstrual Cramps",
      description:
        "Dysmenorrhea is pain associated with menstruation. Your pharmacist can prescribe medications that can help.",
    },
    {
      title: "Insect bites & Hives",
      description:
        "Insect bites from fleas,mosquitos, ants and ticks may cause redness, stinging and rash. Talk to your pharmacist today to discuss treatment options.",
    },
    {
      title: "Tick bites",
      description:
        "Lyme disease is caused from bacteria spread to people through the bite of an infected tick. Your pharmacist can prescribe a medication to prevent this condition.",
    },
    {
      title: "Impetigo",
      description:
        "Impetigo is a bacterial infection presented as a yellowish crust on face, arms or legs. It is contagious but treatable.",
    },
    {
      title: "Muscle sprains & strains",
      description:
        "A sprain is a pulled muscle while a strain is a ligament tear. Treatment options are available for both conditions.",
    },
    {
      title: "Acne",
      description:
        "Acne is a skin condition that develops when your skin pores are clogged. This results in the formation of black heads, white heads and pimples on the skin.",
    },
    {
      title: "Pinworms",
      description:
        "Pinworms are thread like worms that live in the rectum and causes anal  itching, specially at night when worms lay their eggs on nearby skin.",
    },
    {
      title: "Canker Sores",
      description:
        "Cancker sores, also know as aphthous ulcers, are small shallow lesions that occur on tongue or the inside of cheeks or lips.",
    },
    {
      title: "Diaper Rash",
      description:
        "Diaper dermatitis is an inflammation of the skin of the diaper area due to irritants , bacteria or yeast.",
    },
    {
      title: "Nause & Vomiting in Pregnancy",
      description:
        "Morning sickness usually begins in the 1st trimester and subsides in the 2nd trimester. It affects 70-80% of all pregnant women.",
    },
  ];

  return (
    <div className="minor-ailments-page">
      <section className="hero py-10">
        <div className="hero-overlay">
          <h1>GOT A MINOR AILEMNT?</h1>
          <p>Pharmacists can now prescribe for minor health conditions.</p>
          <a
            className="cta-button"
            href="https://bookmypharmacy.com/9057499990"
          >
            Book Appointment
          </a>
        </div>
      </section>

      <section className="info-section">
        <p>
          Pharmacists in Ontario can prescribe for minor health conditions. If
          you have an Ontario health card, you're eligible for this free
          service. Our pharmacist can assess your symptoms, discuss treatment
          options and provide recommendations to prevent recurrence — No
          Appointments Necessary.
        </p>
      </section>

      <section className="cards-section">
        <div className="cards-container">
          {ailments.map((ailment, idx) => (
            <div key={idx} className="ailment-card">
              <h3>{ailment.title}</h3>
              <p>{ailment.description}</p>
            </div>
          ))}
        </div>
      </section>

      <ConsultationBookingModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleBookingSubmit}
      />
    </div>
  );
};

export default MinorAilments;
